import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import "./responsive.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Dashboard from "./pages/Dashboard";
import Header from "./Components/Header";
import Sidebar from "./Components/Sidebar";
import { createContext, useEffect, useState } from "react";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Products from "./pages/Products";
import Homepageimage from "./pages/Homepageimage/homepageimagelist";
import AddHomepageimage from "./pages/Homepageimage/addhomepageimage";
import EditHomepageimage from "./pages/Homepageimage/edithomepageimage";
import Mobileimage from "./pages/Mobileimage/mobileimagelist";
import AddMobileimage from "./pages/Mobileimage/addmobileimage";
import EditMobileimage from "./pages/Mobileimage/editmobileimage";
import ProductUpload from "./pages/Products/addProduct";
import Category from "./pages/Category/categoryList";
import AddCategory from "./pages/Category/addCategory";
import EditCategory from "./pages/Category/editCategory";

import { Snackbar, Alert } from "@mui/material";
import LoadingBar from "react-top-loading-bar";
import EditProduct from "./pages/Products/editProduct";
import { fetchDataFromApi } from "./utils/api";
import TopMaterial from "./pages/TopMaterial/topMaterialList";
import AddTopMaterial from "./pages/TopMaterial/addTopMaterial";
import AddTopFinish from "./pages/TopFinish/addTopFinish";
import TopFinish from "./pages/TopFinish/topFinishList";
import AddLegMaterial from "./pages/LegMaterial/addLegMaterial";
import LegMaterial from "./pages/LegMaterial/legMaterialList";
import LegFinish from "./pages/LegFinish/legFinishList";
import AddLegFinish from "./pages/LegFinish/addLegFinish";
import Top from "./pages/Top/topList";
import AddTop from "./pages/Top/addTop";
import AddEdge from "./pages/Edge/addEdge";
import Edge from "./pages/Edge/edgeList";
import AddFinish from "./pages/Finish/addFinish";
import Finish from "./pages/Finish/finishList";
import ProductTops from "./pages/ProductTops/productTopsList";
import AddProductTops from "./pages/ProductTops/addProductTops";
import ProductEdges from "./pages/ProductEdges/productEdgesList";
import AddProductEdges from "./pages/ProductEdges/addProductEdges";
import ProductFinish from "./pages/ProductFinishes/productFinishList";
import AddProductFinish from "./pages/ProductFinishes/addProductFinish";
import EditFinish from "./pages/Finish/editFinish";
import EditEdge from "./pages/Edge/editEdge";
import EditTop from "./pages/Top/editTop";
import VariantGroup from "./pages/variantGroup/variantGroupList";
import AddVariantGroup from "./pages/variantGroup/addVariantGroup";
import EditVariantGroup from "./pages/variantGroup/editVariantGroup";
import AddMaterial from "./pages/material/addMaterial";
import Material from "./pages/material/materialList";
import ProtectedRoute from "./Components/PrivateRoute";

const MyContext = createContext();

function App() {
  const [isToggleSidebar, setIsToggleSidebar] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const [isHideSidebarAndHeader, setisHideSidebarAndHeader] = useState(false);
  const [catData, setCatData] = useState([]);
  const [productList, setProductList] = useState([]);
  const [isOpenNav, setIsOpenNav] = useState(false);

  const [user, setUser] = useState({
    name: "",
    email: "",
    userId: "",
  });

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [baseUrl, setBaseUrl] = useState(process.env.REACT_APP_BASE_URL);

  const [progress, setProgress] = useState(0);

  const [alertBox, setAlertBox] = useState({
    msg: "",
    error: false,
    open: false,
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    const loginTime = localStorage.getItem("loginTime");
    const userData = localStorage.getItem("user");

    const isTokenValid = token && token !== "" && token !== "undefined";
    const isLoginTimeValid = loginTime && !isNaN(Number(loginTime));
    const isUserValid = userData && userData !== "undefined";

    const now = Date.now();
    const twentyFourHours = 24 * 60 * 60 * 1000;

    if (isTokenValid && isLoginTimeValid && isUserValid) {
      const timeElapsed = now - Number(loginTime);

      if (timeElapsed < twentyFourHours) {
        setIsLogin(true);

        try {
          const parsedUser = JSON.parse(userData);
          setUser(parsedUser);
        } catch (err) {
          // If localStorage user is corrupted
          localStorage.clear();
          window.location.href = "/login";
        }
      } else {
        // Token expired
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("loginTime");

        setIsLogin(false);
        window.location.href = "/login";
      }
    } else {
      setIsLogin(false);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setProgress(20);

    fetchCategory();

    fetchDataFromApi(`/api/products`).then((res) => {
      setProductList(res);
    });
  }, []);

  const fetchCategory = () => {
    fetchDataFromApi("/api/category").then((res) => {
      setCatData(res);
      setProgress(100);
    });
  };

  const openNav = () => {
    setIsOpenNav(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertBox({
      open: false,
    });
  };

  const values = {
    isToggleSidebar,
    setIsToggleSidebar,
    isLogin,
    setIsLogin,
    isHideSidebarAndHeader,
    setisHideSidebarAndHeader,
    windowWidth,
    openNav,
    isOpenNav,
    setIsOpenNav,
    alertBox,
    setAlertBox,
    progress,
    setProgress,
    baseUrl,
    catData,
    fetchCategory,
    setUser,
    user,
    setProductList,
    productList,
  };

  return (
    <BrowserRouter>
      <MyContext.Provider value={values}>
        <LoadingBar
          color="#f11946"
          progress={progress}
          onLoaderFinished={() => setProgress(0)}
          className="topLoadingBar"
        />

        <Snackbar
          open={alertBox.open}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={alertBox.error === false ? "success" : "error"}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {alertBox.msg}
          </Alert>
        </Snackbar>

        {isHideSidebarAndHeader !== true && <Header />}
        <div className="main d-flex">
          {isHideSidebarAndHeader !== true && (
            <>
              <div
                className={`sidebarOverlay d-none ${
                  isOpenNav === true && "show"
                }`}
                onClick={() => setIsOpenNav(false)}
              ></div>
              <div
                className={`sidebarWrapper ${
                  isToggleSidebar === true ? "toggle" : ""
                } ${isOpenNav === true ? "open" : ""}`}
              >
                <Sidebar />
              </div>
            </>
          )}

          <div
            className={`content ${isHideSidebarAndHeader === true && "full"} ${
              isToggleSidebar === true ? "toggle" : ""
            }`}
          >
            <Routes>
              {/* PUBLIC */}
              <Route path="/login" element={<Login />} />
              <Route path="/signUp" element={<SignUp />} />

              {/* PRIVATE */}
              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/homepageimage" element={<Homepageimage />} />
                <Route
                  path="/homepageimage/add"
                  element={<AddHomepageimage />}
                />
                <Route
                  path="/homepageimage/edit/:id"
                  element={<EditHomepageimage />}
                />
                <Route path="/mobileimage" element={<Mobileimage />} />
                <Route path="/mobileimage/add" element={<AddMobileimage />} />
                <Route
                  path="/mobileimage/edit/:id"
                  element={<EditMobileimage />}
                />
                <Route path="/products" element={<Products />} />
                <Route path="/product/upload" element={<ProductUpload />} />
                <Route path="/product/edit/:id" element={<EditProduct />} />
                <Route path="/variantGroup" element={<VariantGroup />} />
                <Route path="/variantGroup/add" element={<AddVariantGroup />} />
                <Route
                  path="/variantGroup/edit/:id"
                  element={<EditVariantGroup />}
                />
                <Route path="/category" element={<Category />} />
                <Route path="/category/add" element={<AddCategory />} />
                <Route path="/category/edit/:id" element={<EditCategory />} />
                <Route path="/legFinish" element={<LegFinish />} />
                <Route path="/legFinish/add" element={<AddLegFinish />} />
                <Route path="/legMaterial" element={<LegMaterial />} />
                <Route path="/legMaterial/add" element={<AddLegMaterial />} />
                <Route path="/topFinish" element={<TopFinish />} />
                <Route path="/topFinish/add" element={<AddTopFinish />} />
                <Route path="/topMaterial" element={<TopMaterial />} />
                <Route path="/topMaterial/add" element={<AddTopMaterial />} />
                <Route path="/material" element={<Material />} />
                <Route path="/material/add" element={<AddMaterial />} />
                <Route path="/top" element={<Top />} />
                <Route path="/top/add" element={<AddTop />} />
                <Route path="/top/edit/:id" element={<EditTop />} />
                <Route path="/edge" element={<Edge />} />
                <Route path="/edge/add" element={<AddEdge />} />
                <Route path="/edge/edit/:id" element={<EditEdge />} />
                <Route path="/finish" element={<Finish />} />
                <Route path="/finish/add" element={<AddFinish />} />
                <Route path="/finish/edit/:id" element={<EditFinish />} />
                <Route path="/productTop" element={<ProductTops />} />
                <Route path="/productTop/add" element={<AddProductTops />} />
                <Route path="/productEdge" element={<ProductEdges />} />
                <Route path="/productEdge/add" element={<AddProductEdges />} />
                <Route path="/productFinish" element={<ProductFinish />} />
                <Route
                  path="/productFinish/add"
                  element={<AddProductFinish />}
                />
              </Route>
            </Routes>
          </div>
        </div>
      </MyContext.Provider>
    </BrowserRouter>
  );
}

export default App;
export { MyContext };
